import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Coins, LogOut, PenLine, LayoutDashboard, History as HistoryIcon, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    // Hard-redirect to home so a ProtectedRoute can't intercept the transition
    // (setUser(null) would otherwise bounce the current protected page to /login).
    window.location.href = "/";
  };

  const navItem = (to, label, Icon) => {
    const active = location.pathname === to;
    return (
      <Link
        to={to}
        data-testid={`nav-${label.toLowerCase()}`}
        className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-colors ${
          active ? "bg-[#2D6A4F] text-[#FDFDF9]" : "text-[#525252] hover:text-[#2D6A4F] hover:bg-[#EAF1ED]"
        }`}
      >
        <Icon className="w-4 h-4" /> {label}
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-40 bg-[#FDFDF9]/95 backdrop-blur border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/dashboard" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-[#2D6A4F] flex items-center justify-center">
            <PenLine className="w-4 h-4 text-[#FDFDF9]" />
          </div>
          <span className="font-display text-xl tracking-tight text-[#1C1C1C]">MainsMentor</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItem("/dashboard", "Dashboard", LayoutDashboard)}
          {navItem("/evaluate", "Evaluate", PenLine)}
          {navItem("/history", "History", HistoryIcon)}
          {user?.role === "admin" && navItem("/admin", "Admin", Shield)}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/buy-credits"
            data-testid="nav-credits"
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FBEEE8] text-[#B0452A] text-sm font-semibold border border-[#F3D9CE] hover:bg-[#F8E2D8] transition-colors"
          >
            <Coins className="w-4 h-4" />
            {user?.credits ?? 0} {(user?.credits ?? 0) === 1 ? "credit" : "credits"}
          </Link>
          <Button
            data-testid="logout-btn"
            variant="ghost"
            size="icon"
            onClick={handleLogout}
            className="text-[#525252] hover:text-[#2D6A4F]"
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
